import { IconMap, IconComponent, IconName } from './types';
import { darkThemeIconMap } from './dark';
import { footlockerIconMap } from './footlocker';
import { lightThemeIconMap } from './light';

// Theme-based icon implementations — themeName comes from remote config
const THEME_ICON_MAP: Record<string, IconMap> = {
  light: lightThemeIconMap,
  dark: darkThemeIconMap,
  footlocker: footlockerIconMap,
};

/**
 * Get icon map for store. Resolves theme-based icons using the provided themeName.
 */
export const getStoreIconMap = (themeName: string = 'light'): IconMap => {
  return THEME_ICON_MAP[themeName] || lightThemeIconMap;
};

/** @internal */
export const getIconMapForStore = getStoreIconMap;

/**
 * Get fallback icon (always uses light theme icons, not theme-aware)
 * For theme-aware icons based on remote config, use useStoreIcon hook instead
 */
export const getFallbackIcon = (
  iconName: IconName,
  variant: 'default' | 'filled' = 'default'
): IconComponent => {
  const iconEntry = lightThemeIconMap[iconName];

  if (!iconEntry) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(
        `[Icons] Icon "${iconName}" not found. Use useStoreIcon hook for store-aware icons.`,
        '\nAvailable:', Object.keys(lightThemeIconMap).slice(0, 10).join(', ') + '...'
      );
    }
    return (() => null) as IconComponent;
  }

  const icon = variant === 'filled' && iconEntry.filled
    ? iconEntry.filled
    : iconEntry.default;

  return icon;
};

/** @deprecated Use getFallbackIcon */
export const getStoreIcon = getFallbackIcon;

export { IconName } from './types';
export type { IconComponent, IconMap, IconMapEntry, StoreConfig } from './types';
export { useStoreIcon, useStoreIconMap } from './hooks';
export { resolveThemeColor, formatAvailableIcons } from './utils';
